import { isSubNavigationA } from '@core/typeguards';
import { ReactComponent as SvgLinkArrow } from '@img/icons/button-arrow.svg';
import { ReactComponent as SvgArrow } from '@img/icons/portal-arrow.svg';
import * as React from 'react';
import S from './NavigationMobile.styles';
const NavigationMobile = (props) => {
    const [activeItem, setActiveItem] = React.useState();
    const [activeSubItem, setActiveSubItem] = React.useState();
    /** Unset active states when menu is closed */
    React.useEffect(() => {
        if (!props.active) {
            setActiveItem('');
            setActiveSubItem('');
        }
    }, [props.active]);
    return (React.createElement(S.Container, { "data-active": props.active, "aria-label": "Mobile navigation" },
        React.createElement(S.TopLinks, null, props.items.map((item) => (React.createElement("li", { key: `mobile-nav-item-${item.id}` },
            React.createElement(S.TopLink, { href: item.url, target: item.target, onClick: (e) => {
                    if (item.children) {
                        e.preventDefault();
                        setActiveItem(item.id);
                    }
                } }, item.text),
            React.createElement(S.ItemContainer, { "data-active": activeItem === item.id }, item.children !== null && item.children.length > 0 && (React.createElement("ul", null,
                React.createElement("li", { key: `mobile-nav-back-${item.id}` },
                    React.createElement(S.BackButton, { onClick: () => setActiveItem(undefined) }, `< Back`)),
                React.createElement("li", { key: `mobile-nav-sub-header-${item.id}` },
                    React.createElement(S.SubHeader, null, item.text)),
                React.createElement("li", { key: `mobile-nav-view-all-${item.id}` },
                    React.createElement(S.GeneralLink, { href: item.url, target: item.target, "data-view-all": true },
                        React.createElement("span", null,
                            "View All ",
                            item.text),
                        React.createElement(SvgLinkArrow, null))),
                item.children.map((subItem) => (React.createElement(React.Fragment, null,
                    React.createElement("li", { key: `mobile-nav-item-${subItem.id}` },
                        React.createElement(S.TopLink, { href: subItem.url, target: subItem.target, onClick: (e) => {
                                if (isSubNavigationA(subItem)) {
                                    e.preventDefault();
                                    setActiveSubItem(subItem.id);
                                }
                            } },
                            isSubNavigationA(subItem) && React.createElement(S.PreText, null, subItem.preText),
                            React.createElement("span", null, subItem.text))),
                    React.createElement("li", null,
                        React.createElement(S.ItemContainer, { "data-active": activeSubItem === subItem.id }, activeItem === item.id && isSubNavigationA(subItem) && subItem.children && (React.createElement("ul", null,
                            React.createElement("li", { key: `mobile-nav-back-${subItem.id}` },
                                React.createElement(S.BackButton, { onClick: () => setActiveSubItem(undefined) }, `< Back`)),
                            React.createElement("li", { key: `mobile-nav-sub-header-${subItem.id}` },
                                React.createElement(S.SubHeader, null, subItem.preText)),
                            subItem.children.map((child) => (React.createElement("li", { key: child.id },
                                React.createElement(S.GeneralLink, { href: child.url, target: child.target },
                                    React.createElement("span", null, child.text),
                                    React.createElement(SvgLinkArrow, null)),
                                child.children && (React.createElement(S.LinkList, null, child.children?.map((c) => (React.createElement("li", { key: c.id },
                                    React.createElement(S.GeneralLink, { href: c.url, target: c.target },
                                        React.createElement("span", null, c.text),
                                        React.createElement(SvgLinkArrow, null)))))))))))))))))))))))),
        props.quickLinks && (React.createElement(S.QuickLinks, null, props.quickLinks.map((link) => (React.createElement("li", { key: `header-quicklink-${link.id}` },
            React.createElement(S.QuickLink, { href: link.url, target: link.target },
                link.hasArrow && React.createElement(SvgArrow, null),
                link.text)))))),
        React.createElement(S.EnquiriesButton, { buttonType: "outline-alt", noIcon: true, href: props.enquiriesCTA?.url, target: props.enquiriesCTA?.target, "data-active": activeItem !== '' && activeItem !== undefined }, props.enquiriesCTA?.text),
        React.createElement(S.FindApartmentCTA, { align: "center", buttonType: "plain", noIcon: true, href: props.findAnApartmentCTA?.url, target: props.findAnApartmentCTA?.target, "data-active": activeItem !== '' && activeItem !== undefined }, props.findAnApartmentCTA?.text)));
};
export default NavigationMobile;
